import React, { useState, useMemo, useRef } from 'react'
import { useIntl } from 'react-intl'
import AnimateHeight from 'react-animate-height'

import { cn, formatPrice } from 'utils'
import useOnClickOutside from 'hooks/useOnClickOutside'
import { ArrowDownWide as ArrowIcon } from 'components/Icons'
import { FloatingPriceWrapper } from 'components/FloatingPrice'
import { isAnyFloatingPriceInCart } from '../utils'
import Content from './Content'
import PlaceOrderRow from './PlaceOrderRow'

import messages from '../messages'

const SummaryBoxMobile = ({ userData, cartData }) => {
  const ref = useRef(null)
  const { formatMessage } = useIntl()
  const [isExpanded, setIsExpanded] = useState(false)

  const { totalPrice } = cartData

  const hasFloatingPrice = useMemo(() => isAnyFloatingPriceInCart(cartData), [
    cartData,
  ])

  const collapseSummaryBox = () => {
    if (isExpanded) setIsExpanded(false)
  }
  useOnClickOutside(ref, collapseSummaryBox)

  return (
    <div
      ref={ref}
      className="sticky bottom-0 flex flex-col w-full p-4 rounded-t-[20px] bg-[#FFFFFFB8] backdrop-blur-xl shadow-[0px_-6px_30px_-8px_#45827D33] items-center"
    >
      <AnimateHeight
        className="w-full"
        contentClassName="w-full"
        duration={150}
        height={isExpanded ? 'auto' : 0}
      >
        <Content userData={userData} cartData={cartData} />
      </AnimateHeight>
      <div className="flex w-full gap-4">
        <button
          data-test-id="cart-summary_expand-btn"
          type="button"
          onClick={() => setIsExpanded(state => !state)}
          className={cn(
            'transition duration-300 ease-out rotate-180',
            isExpanded && 'rotate-0',
          )}
        >
          <ArrowIcon />
        </button>
        <PlaceOrderRow cartData={cartData}>
          <button
            data-test-id="cart-summary_mobile-total-sum-container"
            type="button"
            className="flex flex-col text-left"
            onClick={() => setIsExpanded(state => !state)}
          >
            <span className="text-12 leading-4">
              {formatMessage(messages.totalGross)}
            </span>
            <FloatingPriceWrapper hasFloatingPrice={hasFloatingPrice}>
              <span className="text-[20px] leading-[30px] font-semibold">
                {formatPrice(totalPrice.gross)}
              </span>
            </FloatingPriceWrapper>
          </button>
        </PlaceOrderRow>
      </div>
    </div>
  )
}

export default SummaryBoxMobile
